import { useState } from 'react';
import { FileText, Save, Download, Printer, RefreshCw, Check, AlertCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { toast } from 'sonner';

const ContractGenerator = () => {
  const [template, setTemplate] = useState('');

  return (
    <div className="p-6 max-w-7xl mx-auto space-y-6">
      <div className="border-b pb-4">
        <h1 className="text-2xl font-black uppercase">Contract Suite</h1>
        <p className="text-xs font-mono text-muted-foreground uppercase">Automated legal documentation & agreement generation</p>
      </div>

      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-5 space-y-4">
          <Card>
            <CardHeader><CardTitle className="text-sm font-bold uppercase tracking-widest text-muted-foreground">Agreement Parameters</CardTitle></CardHeader>
            <CardContent className="space-y-4">
               <div>
                 <label className="text-[10px] font-bold uppercase mb-1 block">Contract Type</label>
                 <Select value={template} onValueChange={setTemplate}>
                    <SelectTrigger><SelectValue placeholder="Select Agreement Type" /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="land">Land Purchase Agreement</SelectItem>
                      <SelectItem value="assignment">Assignment of Sale</SelectItem>
                      <SelectItem value="finance">Seller Financing</SelectItem>
                      <SelectItem value="loi">Letter of Intent (LOI)</SelectItem>
                    </SelectContent>
                 </Select>
               </div>
               <Button className="w-full h-12 font-black uppercase italic bg-primary hover:bg-primary/90">Initialize Generator</Button>
            </CardContent>
          </Card>
        </div>

        <div className="col-span-7">
          <Card className="border-4 border-dashed h-[500px] flex items-center justify-center p-20 text-center opacity-30">
            <div>
              <FileText size={64} className="mx-auto mb-4" />
              <p className="text-xl font-black italic uppercase">Vault Locked</p>
              <p className="text-sm mt-2">Select a template and property to generate agreement preview.</p>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ContractGenerator;
